<template>
       <v-overlay
      :opacity="0.4"
      :value="globalStore.loader.open"
    >
      <v-progress-circular  indeterminate size="150" width="8">
        {{ globalStore.loader.message ? globalStore.loader.message : 'Cargando...' }}
      </v-progress-circular>
    </v-overlay>
</template>
<script>
  import {useGlobalActionsStore} from '../../stores/GlobalActionsStore';
  export default {
    data () {
      return {
        globalStore: useGlobalActionsStore(),
      }
    }
  }
</script>
